export default "__VITE_ASSET__CaPHGykS__"